var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencySelectorChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.722 1.578L7.15 7.15a.898.898 0 01-1.3 0L.278 1.578a.898.898 0 010-1.3.898.898 0 011.3 0L6.5 5.2 11.421.278a.898.898 0 011.3 0 .898.898 0 010 1.3z",
    fill: "#75E8F0"
  })));
}
export default SvgCurrencySelectorChevron;